<template>
  <div class="association">
    <!-- banner部分的内容 -->
    <Carousel :bannerUrl="bannerUrl">
      <template v-slot:dataMesg>
        <div class="dataMesg">
          <div
            class="data_box"
            v-for="(item, index) in bannerData"
            :key="index"
          >
            <p>
              <VueCountUp :start-value="0" :end-value="item.nums" :duration="2" :delay="2"  />
              {{ item.unit }}
            </p>
            <p>{{ item.name }}</p>
          </div>
        </div>
      </template>
    </Carousel>
    <!-- 需求方和服务方 -->
    <demandAndServer></demandAndServer>
    <!-- 热门需求 -->
    <hotRequirement></hotRequirement>
    <!-- 服务市场 -->
    <serviceMarket></serviceMarket>
    <!-- 对接动态/线下撮合 -->
    <dynamics></dynamics>
    <!-- 线下撮合 -->
    <offline></offline>
    <!-- 对接案例 -->
    <dockCase></dockCase>
    <!-- 优质服务商 -->
    <qualityServiceProvider></qualityServiceProvider>
  </div>
</template>

<script>

import VueCountUp from 'vue-countupjs'
// 轮播
import Carousel from "../carousel/carousel";
import demandAndServer from "./demandAndServer";
import hotRequirement from "./hotRequirement";
import serviceMarket from "./serviceMarket";
import dynamics from "./dynamics";
import dockCase from "./dockCase";
import offline from "./offline";
import qualityServiceProvider from "./qualityServiceProvider";
import {getBannerList, getNewcurrent, getResourceTotalList} from "../../utils/interface";
import {mapState} from "vuex";
export default {
  components: {
    VueCountUp,
    Carousel,
    demandAndServer,
    hotRequirement,
    serviceMarket,
    dynamics,
    dockCase,
    offline,
    qualityServiceProvider,
  },
  data() {
    return {
      bannerUrl: [
      ],
      bannerData: [
        {
          nums: "0",
          unit: "条",
          name: "累计发布需求",
        },
        {
          nums: "0",
          unit: "条",
          name: "累计发布服务",
        },
        {
          nums: "0",
          unit: "家",
          name: "入驻平台服务商",
        },
        {
          nums: "0",
          unit: "万",
          name: "促成交易规模",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.loadBanner();
      }
    }, 500);
    this.resourceTotal();
  },
  mounted() {
  },
  methods:{
    loadBanner(){
      getBannerList({groupCode: 'RESOURCE_BANNER'}).then((res)=>{
        this.bannerUrl = res;
      });
    },
    resourceTotal(){
      getResourceTotalList({}).then((res)=>{
        this.bannerData[0].nums = res.data.demandNum;
        this.bannerData[1].nums = res.data.serviceNum;
        this.bannerData[2].nums = res.data.enterpriseNum;
        this.bannerData[3].nums = res.data.totalPrice;
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "./style/index.less";
.dataMesg {
  position: absolute;
  bottom: 14%;
  left: 57%;
  transform: translate(-15%, 0);
  background: transparent;
  color: #fff;
  display: flex;
  .data_box {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    margin-right: 40px;
    span {
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #dc3223;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/index.vue